import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { ApiCallConfig } from "@src/utils/api-client";

export function buildUserLeadConfig(userId: string, salesforceLeadId: string): ApiCallConfig {
  return {
    method: HTTP_METHODS.PATCH,
    endpoint: INTERNAL_API_ENDPOINTS.USER_LEAD,
    body: { userId, salesforce_lead_id: salesforceLeadId },
  };
}
